<div 
  class="badge"
  [class.badge-large]="size === 'large'"
  [ngClass]="'badge-' + variant">
  
  <!-- Dot indicator -->
  <span 
    *ngIf="indicator === 'dot'" 
    class="badge-dot">
  </span>

  <!-- Icon indicator -->
  <hyperkit-icon 
    *ngIf="indicator === 'icon'"
    [icon]="icon"
    size="small"
    color="inherit"
    class="badge-icon">
  </hyperkit-icon>

  <hyperkit-typography [variant]="typographyVariant" color="inherit">{{text}}</hyperkit-typography>
</div>